import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { Observable } from 'rxjs';
import { UserCreatePayload } from '../models/user-create-model';

@Injectable({
  providedIn: 'root',
})
export class UserMasterService {
  constructor(private http: HttpClient) {}

  lFN_GetUserList() {
    return this.http.get(`${environment.ROOT_URL}/user/users`, {
      withCredentials: false,
      responseType: 'text',
      observe: 'response',
    });
  }

  lFN_SaveUser(payload: UserCreatePayload) {
    return this.http.post(
      `${environment.ROOT_URL}/user/create`,
      payload,  
      {
        withCredentials: false,
        observe: 'response',
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        })
      }
    );
  }

  lFN_GetUserById(userId: number) {
    return this.http.get(`${environment.ROOT_URL}/user/user-id/${userId}`, {
      withCredentials: false,
      responseType: 'text',
      observe: 'response',
    });
  }

  lFN_ToggleUserStatus(userId: number) {
  return this.http.patch(
    `${environment.ROOT_URL}/user/status/user-id/${userId}`,
    {},
    { observe: 'response', responseType: 'json' }
  );
}

  lFN_UpdateUser(payload: any) {
    return this.http.put(
      `${environment.ROOT_URL}/user/update`,
      payload,
      {
        withCredentials: false,
        observe: 'response',
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        })
      }
    );
  }



  // lFN_GetBookById(bookId: number) {
  //     return this.http.get(`${environment.ROOT_URL}/jsyoglibrary/bookDetail/bookId/` + bookId, { withCredentials: false, responseType: 'text', observe: 'response' });
  // }

  // lFN_UpdateBookById(bookId: number, bookData: Book) {
  //     return this.http.put(`${environment.ROOT_URL}/jsyoglibrary/book/bookId/` + bookId, bookData, { withCredentials: false, responseType: 'text', observe: 'response' });
  // }
}
